import { render, staticRenderFns } from "./LibroDetailCard.vue?vue&type=template&id=6d5e703f&scoped=true&"
import script from "./LibroDetailCard.vue?vue&type=script&lang=ts&"
export * from "./LibroDetailCard.vue?vue&type=script&lang=ts&"
import style0 from "./LibroDetailCard.vue?vue&type=style&index=0&id=6d5e703f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5e703f",
  null
  
)

export default component.exports